import RatingButtons from "./RatingButtons";
import TextArea from "../Formik/TextArea";
import React from "react";

const SubmitReviewStep2 = ({formik, vendorData}) => {

    return <div className="sl-display-flex sl-flex-col sl-gap-8">

        <div className="sl-display-flex sl-flex-col sl-width-100 sl-gap-2 sl-text-left">

            <span className="sl-font sl-font-medium sl-text-lg sl-text-gray-900 ">3.On a scale of 0 to 10, where 0 is the worst and 10 is the best, how would you rate {vendorData.company.name} in these areas?</span>
            <RatingButtons label={'Profile (experience, stability, size)'} formik={formik} name={'q0'}/>
            <RatingButtons label={'Vision (strategic support and program approach)'} formik={formik}
                           name={'q1'}/>
            <RatingButtons label={'Potential (scalability, innovation, roadmap)'} formik={formik}
                           name={'q2'}/>
            <RatingButtons label={'Product (scope od services, product-to-need fit)'} formik={formik}
                           name={'q3'}/>
            <RatingButtons label={'Technology (user experience, functionality, adaptability)'}
                           formik={formik}
                           name={'q4'}/>
            <RatingButtons label={'Flexibility (configurability, customizability)'} formik={formik}
                           name={'q5'}/>
            <RatingButtons label={'Implementation (timeframe, resources, strategy, execution)'}
                           formik={formik}
                           name={'q6'}/>
            <RatingButtons label={'Data (integrations, reporting, insights)'} formik={formik}
                           name={'q7'}/>
            <RatingButtons label={'People (account team, leadership, sales rep)'} formik={formik}
                           name={'q8'}/>
            <RatingButtons label={'Support (responsiveness, issue resolution, proactivity)'}
                           formik={formik}
                           name={'q9'}/>

        </div>

        <div className="sl-display-flex sl-flex-col sl-width-100 sl-gap-2 sl-text-left ">


            <span className="sl-font sl-font-medium sl-text-lg sl-text-gray-900 ">4.How likely is it that you would recommend this company to a friend or colleague?</span>


            <RatingButtons label={`Recommend ${vendorData.company.name}?`}
                           formik={formik}
                           name={'q10'}/>


            <div className="sl-display-flex sl-flex-row sl-justify-space-between">

            </div>
        </div>
        <TextArea
            label={"5.What improvements would you suggest for this company to achieve a higher rating from you?"}
            formik={formik} name={'changes'}/>

    </div>
}

export default SubmitReviewStep2;